import React from 'react';
import '../App.css'; 

function AboutMe() {
    return (
        <section className="about-me" id="about">
            <div className="about-me-content">
                <h2>About Me</h2>
                <p>
                    As a software engineer specializing in backend development, I possess a strong passion for tackling intricate challenges and ensuring functionality.
                    
                    Proficient in crafting REST APIs and adept at utilizing Java, JavaScript, and Python, I thrive within agile frameworks.
                </p>
            </div>
        </section>
    );
}

export default AboutMe;